"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _addBanner = _interopRequireDefault(require("../addBanner"));
var _shop = require("@/api/shop");
var _default = {
  components: {
    customPage: _customPage.default,
    addBanner: _addBanner.default
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      editId: ''
    };
  },
  methods: {
    // 上架/下架
    changeStatus: function changeStatus(id, status) {
      var _this = this;
      var tip = "",
        title = "";
      if (status == 1) {
        tip = "您确定要下架吗？";
        title = "下架";
      } else {
        tip = "您确定要上架吗？";
        title = "上架";
      }
      this.$confirm(tip, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _shop.addOrEdiShopBanner)({
          id: id,
          status: status == 1 ? 2 : 1
        }).then(function (res) {
          _this.getList();
        });
      }).catch(function () {});
    },
    // 更改排序
    changeSort: function changeSort(id, val) {
      var _this2 = this;
      (0, _shop.addOrEdiShopBanner)({
        id: id,
        sort: val
      }).then(function (res) {
        _this2.getList();
      });
    },
    openAddDialog: function openAddDialog(id) {
      this.editId = id ? id : null;
      this.$refs.addBanner.dialogVisible = true;
    },
    // 删除
    removeItem: function removeItem(id) {
      var _this3 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _shop.delShopBanner)(id).then(function (res) {
          _this3.getList();
        });
      }).catch(function () {});
    },
    getList: function getList() {
      var _this4 = this;
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _shop.shopBannerList)({
        page: page,
        pageSize: pageSize
      }).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.total = res.total;
      });
    }
  },
  mounted: function mounted() {
    this.getList();
  }
};
exports.default = _default;